const roleIdE = {
  SA: 1,
  HA: 2,
  WA: 3, // wardIc
  NURSE: 4,
  CLERK: 5,
  SUPPORTINGSTAFF: 6,
  PRO: 7,
  CC_POWER_USER: 9,
  CC_WARD_USER: 10,
  NOTIFIER: 11,
  ROSTER_ASSISTANT: 12,
  DELEGATED_WA: 13, // Delegated Ward IC
  CC_HA:14 // Hospital Admin (CC)
};

const roleWeight = {
  [roleIdE.SA]: 100,
  [roleIdE.HA]: 90,
  [roleIdE.WA]: 80,
  [roleIdE.DELEGATED_WA]: 80,
  [roleIdE.NURSE]: 0,
  [roleIdE.CLERK]: 0,
  [roleIdE.SUPPORTINGSTAFF]: 0,
  [roleIdE.PRO]: 80,
  [roleIdE.CC_POWER_USER]: 89,
  [roleIdE.CC_WARD_USER]: 0,
  [roleIdE.CC_HA]: 90,
  [roleIdE.NOTIFIER]: 89,
  [roleIdE.ROSTER_ASSISTANT]: 0,
};

const loginRoleWeight = {
  [roleIdE.SA]: 100,
  [roleIdE.HA]: 90,
  [roleIdE.WA]: 89,
  [roleIdE.DELEGATED_WA]: 89,
  [roleIdE.NURSE]: 10,
  [roleIdE.CLERK]: 10,
  [roleIdE.SUPPORTINGSTAFF]: 10,
  [roleIdE.PRO]: 80,
  [roleIdE.CC_POWER_USER]: 0,
  [roleIdE.CC_WARD_USER]: 0,
  [roleIdE.CC_HA]: 90,
  [roleIdE.NOTIFIER]: 0,
  [roleIdE.ROSTER_ASSISTANT]: 0,
};

const NavMenuE = {
  home: 'home',
  eHandover: 'eHandover',
  bedStatus: 'Bed Status',
  setting: 'Setting',
  dutyAssign: 'Duty Assign',
  notification: 'notification',
  equipment: 'equipment',
  televisit: 'televisit',
  wardDrive: 'wardDrive',
  admission: 'admission',
  patient: 'patient',
};

export { loginRoleWeight, roleWeight, NavMenuE, roleIdE };
